import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import NotificationActivity from "@/modules/notification-activity/NotificationActivity";

const routes = [
  {
    path: 'notification-activity',
    name: 'notification-activity',
    component: NotificationActivity,
    meta: {
      requiresAuth: true
    }
  },
];

MenuService.addMenuItem(new MenuItem('/notification-activity', i18n.t('Notification Activity'), 6, 'envelope', [], 'view_notificationactivity'));

export {routes}
